import React from 'react';
import { BookOpenIcon, DrillIcon, GiftIcon, UsersIcon } from 'lucide-react';
const items = [{
  icon: BookOpenIcon,
  label: '9 comprehensive volumes'
}, {
  icon: GiftIcon,
  label: '5 exclusive bonuses'
}, {
  icon: DrillIcon,
  label: '+450 ready-to-use resources'
}, {
  icon: UsersIcon,
  label: 'Teachers, students and educators'
}];
export function SocialProof() {
  return <section className="bg-amber-900 py-5" aria-label="What the teacher ready includes" data-id="element-233" data-mp="3f4v8hstarjc">
      <div className="mx-auto flex max-w-5xl flex-wrap items-center justify-center gap-x-8 gap-y-3 px-4 text-sm font-semibold text-stone-50 sm:justify-between" data-id="element-234" data-mp="8dy9wdju4ol3">
        {items.map(({
        icon: Icon,
        label
      }) => <span key={label} className="inline-flex items-center gap-2" data-id="element-235" data-mp="3ut9awvkfir5p">
            <Icon className="h-5 w-5 text-amber-400" aria-hidden="true" data-id="element-236" data-mp="3urg33cy2y0w4" /> {label}
          </span>)}
      </div>
    </section>;
}